import { apiClient } from '@/helpers/api'
import { handleApiError } from '@/services/errorHandler'
import { defineStore } from 'pinia'
import { useCardStore } from '@/stores/CardStore'
import { useBatchStore } from '@/stores/BatchStore'
import { useBillingStore } from '@/stores/BillingStore'
import { useUserStore } from '@/stores/UserStore'

export const useConfigStore = defineStore('ConfigStore', {
  state: () => ({
    config: {},
    loadingConfig: false,
    loadingConfigInBackground: false,
    hmacHash: null,
    stripeCustomerId: null,
    ignoreConfigUpdate: false,
  }),

  getters: {
    getConfigField() {
      return (key) => {
        return this.config ? this.config[key] : {}
      }
    },

    reactivateAccountModal() {
      return !this.config || this.config.hasActiveSubscription !== false
    },

    hasFeature() {
      const billingStore = useBillingStore()
      const userStore = useUserStore()

      return (featureKey) => {
        if (this.loadingConfig || billingStore.currentPlanIndex === null) return null

        if (!userStore.getEntitlements.length) return false

        return !!(userStore.getEntitlements.find(entitlement => entitlement.name === featureKey))
      }
    }
  },

  actions: {
    async fetchConfigs(options) {
      if (this.loadingConfigInBackground) return

      const cardStore = useCardStore()
      const batchStore = useBatchStore()

      try {
        if (!options?.withoutLoader) {
          this.loadingConfig = true
        }

        this.loadingConfigInBackground = true

        const { data } = await apiClient().get('/config')

        this.config = data

        if (!data) return

        this.hmacHash = data.hmac_hash
        this.stripeCustomerId = data.stripe_customer_id

        this.loadingConfig = false
        this.loadingConfigInBackground = false

        cardStore.setCardStoreFields({
          grader: data.graders
        })

        batchStore.selectedBatch && batchStore.updateSelectedBatch({ config: data })
      } catch (error) {
        this.loadingConfig = false
        this.loadingConfigInBackground = false
        handleApiError(error, { component: 'ConfigStore', action: 'fetchConfigs' })
      }
    }
  }
})
